// extracted by mini-css-extract-plugin
export default {"stats":"StatsBar_stats__pwOaw","grid":"StatsBar_grid__nXI83","item":"StatsBar_item__7XLo7","number":"StatsBar_number__bC4XC","label":"StatsBar_label__aJijY"};